<div class="form-field" [formGroup]='parent' 
[ngClass]="{'has-error': parent.get([controlName]) && parent.get([controlName]).touched && parent.get([controlName]).errors}">
<label [id]="controllerData['name']" [attr.for]="pageName+'-'+controllerData['name']" class="form-label">{{pageName === 'yourPensionSavings' ? '' : controllerData['label']}}</label>

  <input [formControlName]="controlName" [name]="controllerData['name']" 
      [type]="controllerData['type']"
      [id]="getId()"
      [(ngModel)]="textValue" 
    [attr.aria-invalid]="(parent.get([controlName]).touched && parent.get([controlName]).errors 
    && controllerData['errorMessage'] && controllerData['errorMessage'] !== '') ? true : false" 
    [placeholder]="controllerData['placeHolder']" 
    [maxlength]="controllerData['maxlength']"
    class="form-control " 
    [value]="(pageName === 'yourPensionSavings' ? textValue : textValue | uppercase)" 
    (blur)="inputTextChangeHandler($event.target.value)"
    [required]="controllerData['required']" 
    (keypress)="addhyphen($event.target.value, $event)"
    [readonly]="controllerData['readonly']"
    autocomplete="off"
    [ngClass]="{'upperCase':toUpperCase}"
    [attr.inputmode]="(isNumeric && isNumeric === true ? 'numeric' : 'text')" 
    />
</div>

<div [id]="controlName+'-error'" class="form-validation-error error-wid" 
[ngClass]="{'width-100':(pageName === 'yourPensionSavings')}"
*ngIf="parent.get([controlName]).touched && parent.get([controlName]).errors
   && controllerData['errorMessage'] 
   && controllerData['errorMessage'] !== ''">
  <i class="icon icon-error" aria-hidden="true"></i>
  <!-- <p [id]="controlName+'-error-msg'" role="alert" 
  aria-live="polite" aria-hidden="false">{{controllerData['errorMessage']}}</p> -->
  <p *ngIf="parent.get(controlName).touched
    &&
    parent.get(controlName).hasError('required')" 
[id]="controlName +'-error'">{{controllerData['errorMessage']}}</p>

 <p *ngIf="parent.get(controlName).touched
       &&
    parent.get(controlName).errors.pattern" [id]="controlName +'-invalid-error'">
    {{controllerData['errorMessageInvalid']}}
</p> 
<p *ngIf="parent.get(controlName).touched
       &&
    parent.get(controlName).hasError('matchInvalid')" [id]="controlName +'-invalid-error'">
    {{controllerData['errorMatch']}}
</p> 
<p *ngIf="parent.get(controlName).touched
       &&
    parent.get(controlName).hasError('notValidPlanNumber')" [id]="controlName +'-invalidPlanNumber-error'">
    {{controllerData['invalidErrorMessage']}}
</p>
<p *ngIf="parent.get(controlName).touched
       &&
    parent.get(controlName).hasError('notValidname')" [id]="controlName +'-invalid-error'">
  {{controllerData['errorMessageInvalid']}}
</p>
</div>